import {
    put, takeLatest, select
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import { generateGetConnectedLinesCoordinates } from '@/constants/apiRoutes'
import createNotifications from '@/helpers/notification'
import { GET_CONNECTED_LINES_COORDINATES } from '@/store/actions/installation'
import {
    errorGetConnectedLinesCoordinates,
    successGetConnectedLinesCoordinates
} from '@/store/actions/installation/getConnectedLinesCoordinates'
import { getGlobalFilters } from '@/store/selectors/appSettings'

function* getConnectedLinesCoordinates({ payload: { id, parentId, objectStates } }) {
    const toast = createNotifications()
    try {
        const {NO_PROBLEM, WARNING, ERROR, UNDEFINED, ...filters} = yield select(getGlobalFilters)
        const statuses = {
          NO_PROBLEM,
          WARNING,
          ERROR,
          UNDEFINED,
        }
        const statusesTrue = Object.keys(statuses).filter((status) => statuses[status])
        const telemetryStatuses = statusesTrue.length === Object.keys(statuses).length ? [] : statusesTrue
        const { data } = yield request({
            url: generateGetConnectedLinesCoordinates({
                params:{
                    id,
                    parentId,
                    objectStates,
                    telemetryStatuses,
                    ...filters,
                }}),
            method: 'get',
        })
        const formattedData = data.content.map(item => {
            return [
                [item.currentPoint.latitude, item.currentPoint.longitude],
                [item.linkedPoint?.latitude, item.linkedPoint?.longitude]
            ]
        })
        yield put(successGetConnectedLinesCoordinates(formattedData))
    } catch (error) {
        if (error.response.data.errorMessage.startsWith('Duplicate')) {
            const identity = error.response.data.details[0].currentIdentity
            const duplicates = error.response.data.details.map(item => {
                return `(${item.name} от ${item.parentName})`
            }).join(', ')
            toast({
                title: 'Ошибка операции!',
                description: `Обнаружен дубликат ${identity} у объектов ${duplicates}`,
                type: 'error',
            })
            return
        }
        yield put(errorGetConnectedLinesCoordinates({}))
        console.log('function*getConnectedLinesCoordinates -> error', error)
        toast({
            title: 'Ошибка операции!',
            description: 'Не удалось получить координаты линий связи \nПовторите попытку позже.',
            type: 'error',
        })
    }
}

export default function* root() {
    yield takeLatest(GET_CONNECTED_LINES_COORDINATES.REQUEST, getConnectedLinesCoordinates)
}